export const aboutActionType = {
    ALL_ABOUT_REQUEST: "ALL_ABOUT_REQUEST",
    ALL_ABOUT_FAIL: "ALL_ABOUT_FAIL",
    ALL_ABOUT_SUCCESS: "ALL_ABOUT_SUCCESS",
  
    SINGLE_ABOUT_REQUEST: "SINGLE_ABOUT_REQUEST",
    SINGLE_ABOUT_FAIL: "SINGLE_ABOUT_FAIL",
    SINGLE_ABOUT_SUCCESS: "SINGLE_ABOUT_SUCCESS",
  
    CREATE_ABOUT_REQUEST: "CREATE_ABOUT_REQUEST",
    CREATE_ABOUT_FAIL: "CREATE_ABOUT_FAIL",
    CREATE_ABOUT_SUCCESS: "CREATE_ABOUT_SUCCESS",
  
    DELETE_ABOUT_REQUEST: "DELETE_ABOUT_REQUEST",
    DELETE_ABOUT_FAIL: "DELETE_ABOUT_FAIL",
    DELETE_ABOUT_SUCCESS: "DELETE_ABOUT_SUCCESS",
  
    UPDATE_ABOUT_REQUEST: "UPDATE_ABOUT_REQUEST",
    UPDATE_ABOUT_FAIL: "UPDATE_ABOUT_FAIL",
    UPDATE_ABOUT_SUCCESS: "UPDATE_ABOUT_SUCCESS",
  };